import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    fetchedWebinar,
    createdWebinar,
    updatedWebinar,
    deletedWebinar,
} from './actions';

export function fetchWebinar(webinarId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/webinars/${webinarId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedWebinar(response.data))
        );
    };
}

export function createWebinar(webinar) {
    const {
        event_id,
        event_title,
        event_short_description,
        start_date,
        sites: webinarSites,
    } = webinar;

    const utc_start_date = formatUTC(webinar.start_date);
    let sites = sanitizeSites(webinarSites);

    console.log('webinar', webinar);
    console.log('start_date', start_date);
    console.log('utc_start_date', start_date);

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/webinars`,
            method: 'POST',
            data: {
                event_id,
                event_title,
                event_short_description,
                start_date: utc_start_date,
                sites,
            },
        };
        return request(options, dispatch)
            .then((response) => dispatch(createdWebinar(response)))
            .then(() =>
                toastr.success('Success!', 'The webinar has been created.')
            )
            .then(() => dispatch(push(`/webinars`)));
    };
}

export function updateWebinar(webinar) {
    const {
        id,
        event_id,
        event_title,
        event_short_description,
        start_date,
        sites: webinarSites,
    } = webinar;

    let sites = sanitizeSites(webinarSites);

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/webinars/${id}`,
            method: 'PUT',
            data: {
                event_id,
                event_title,
                event_short_description,
                start_date,
                sites,
            },
        };

        return request(options, dispatch)
            .then((response) => dispatch(updatedWebinar(webinar)))
            .then(() =>
                toastr.success(
                    'Success!',
                    `Webinar ${webinar.id} has been updated`
                )
            );
    };
}

export function deleteWebinar(webinar) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/webinars/${webinar}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) => dispatch(deletedWebinar(webinar)))
            .then(() =>
                toastr.success(
                    'Success!',
                    `Webinar ${webinar.id} has been deleted`
                )
            );
    };
}

const sanitizeSites = (webinarSites) => {
    let sites = [];

    Object.entries(webinarSites).forEach(([index, item]) => {
        let itemId = item.value;
        sites.push(itemId);
    });

    return sites;
};

const formatUTC = (dateInt) => {
    let date = !dateInt || dateInt.length < 1 ? new Date() : new Date(dateInt);

    const offset = -date.getTimezoneOffset();
    console.log('formatUTC:offset', offset);
    const offsetDate = new Date();
    offsetDate.setTime(date.getTime() + offset * 60000);

    return offsetDate;
};



// WEBPACK FOOTER //
// ./src/containers/webinars/thunks.js